import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Card,
  CardBody,
  Label,
  Row,
  Col,
  FormGroup,
} from "reactstrap";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import Confirm from "components/Confirm";
import { Formik, Field } from "formik";
import { dateFormate } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import { invoiceDetailColumns } from "utils/columns";
import HoverImage from "react-hover-image/build";
import DownloadIcon from "assets/icon/download.svg";
import DownloadIconHover from "assets/icon/download_hover.svg";
import { ModuleAccess } from "utils/moduleaccess";
import Download from "assets/icon/Downloadwhite.svg";

const InvoiceDetail = ({ invoiceId, invoice, tenantID }) => {
  const API = useAxios();
  const [invoiceData, setInvoiceData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchInvoiceDetailData();
  }, []);

  const previewInvoice = (row) => {
    return "";
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      cellRenderer: (row) => previewInvoice(row),
    },
    ...invoiceDetailColumns,
  ];

  const fetchInvoiceDetailData = async () => {
    try {
      setLoading(true);
      const { data } = await API.get(
        `/${tenantID}/Invoice/AllDetails/${invoiceId}`
      );

      setInvoiceData(data);
      setLoading(false);
    } catch (error) {}
  };

  const download = async () => {
    try {
      const { access_token } =
        JSON.parse(sessionStorage.getItem("pharmaforce")) || {};
      const res = await API.get(
        `/${tenantID}/Invoice/Download/${parseInt(
          invoiceId
        )}?access_token=${access_token}`,
        {
          responseType: "blob",
        }
      );
      if (res.request.responseType === "blob") {
        window.open(res.request.responseURL);
      }
    } catch (error) {}
  };

  return (
    <div>
      <Formik>
        <div>
          <Card className="border-0 shadow-top">
            <CardBody className="section-devider-border">
              <Row>
                <Col md={6}>
                  <Row>
                    <Col>
                      <FormGroup>
                        <Label for="invoiceNumber">Invoice Number</Label>
                        <br />
                        <b className="d-inline-block ps-2 font-weight-500">
                          {`${invoice.invoiceNumber || "-"} `}
                        </b>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label for="fromDate">From Date</Label>
                        <br />
                        <b className="d-inline-block ps-2 font-weight-500">
                          {`${dateFormate(invoice.fromInvoiceDate) || "-"} `}
                        </b>
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup>
                        <Label for="toDate">To Date</Label>
                        <br />
                        <b className="d-inline-block ps-2 font-weight-500">
                          {`${dateFormate(invoice.toInvoiceDate) || "-"} `}
                        </b>
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
                <Col md={6} className="m-auto">
                  <Row className="m-auto">
                    <Col className="d-flex justify-content-end">
                      <Button
                        color="primary"
                        className="search"
                        onClick={download}
                        hidden={!ModuleAccess("INV", "INVD")}
                        // style={{ width: "133px", height: "40px" }}
                      >
                        <span className="right_5">
                          <img src={Download} alt="" />
                        </span>{" "}
                        Download
                        {/* <HoverImage
                        key="DownloadIcon"
                        src={DownloadIcon}
                        hoverSrc={DownloadIconHover}
                        alt=""
                        style={{ height: "25px" }}
                      /> */}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row></Row>
            </CardBody>
          </Card>
          <Card className="border-0 shadow-top mt-3">
            <CardBody className="section-devider-border">
              <Row className="">
                <Col>
                  <div
                    className="table-card scroll-table position-relative border-0 rounded pt-0"
                    fixed-height={
                      invoiceData.length > 0 ? "fixed-height" : "default"
                    }
                  >
                    <ReactStrapTable
                      id="invoicedetail-table"
                      fixedColumn
                      data={invoiceData}
                      columns={columns}
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Formik>
    </div>
  );
};

export default InvoiceDetail;
